import React, { useState, useEffect, useRef } from 'react'
import { ACTION } from 'consts/index'
import { useDispatch, useSelector } from 'react-redux'
import MapGL, { Marker } from '@goongmaps/goong-map-react'
import { filterOptionSelect, removeAccents } from 'utils'

//antd
import {
  Input,
  Button,
  Row,
  notification,
  Form,
  Upload,
  Drawer,
  Col,
  Select,
  Space,
  AutoComplete,
  Spin,
} from 'antd'

//components

//icons
import { UploadOutlined } from '@ant-design/icons'

//apis
import { addBranch, updateBranch, getBranches } from 'apis/branch'
import { addReview, updateReview } from 'apis/review'
import { getRegions } from 'apis/region'
import { uploadFile } from 'apis/upload'
import { searchAddress } from 'apis/address'
import { useForm } from 'rc-field-form'

export default function BranchForm({ reloadData, children, infoReview }) {
  const typingTimeoutRef = useRef(null)
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const dataUser = useSelector((state) => state.navigation)

  const [filesView, setFilesView] = useState([])
  const [loadingFile, setLoadingFile] = useState(false)
  const [loadingAddress, setLoadingAddress] = useState(false)
  const [files, setFiles] = useState([])
  const [addressList, setAddressList] = useState([])

  const [branches, setBranches] = useState([])
  const [regions, setRegions] = useState([])
  const [viewport, setViewport] = useState({ latitude: 0, longitude: 0, zoom: 8 })
  const [visible, setVisible] = useState(false)

  const _addOrUpdateReview = async () => {
    try {
      await form.validateFields()
      const formData = form.getFieldsValue()

      if (files.length === 0) {
        notification.warning({ message: 'Vui lòng tải lên ít nhất 1 hình ảnh' })
        return
      }

      const region = regions.find((e) => e.region_id === formData.region_id)

      const body = {
        ...formData,
        avatar_user: files.length > 0 ? files[0] : '',
      }

      dispatch({ type: ACTION.LOADING, data: true })
      let res
      if (infoReview) res = await updateReview(infoReview.review_id, body)
      else res = await addReview(body)

      if (res.status === 200) {
        if (res.data.success) {
          notification.success({
            message: `${infoReview ? 'Cập nhật' : 'Tạo'} review thành công`,
          })
          setVisible(false)
          reloadData()
        } else
          notification.error({
            message:
              res.data.message ||
              `${infoReview ? 'Cập nhật' : 'Tạo'} review thất bại, vui lòng thử lại!`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${infoReview ? 'Cập nhật' : 'Tạo'} review thất bại, vui lòng thử lại!`,
        })
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) {
        setBranches(res.data.data)
      }
    } catch (error) {}
  }

  const _getRegions = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {}
  }
  const onSearchAddress = (value) => {
    try {
      if (value) {
        if (typingTimeoutRef.current) {
          clearTimeout(typingTimeoutRef.current)
        }
        typingTimeoutRef.current = setTimeout(async () => {
          setLoadingAddress(true)
          setAddressList([])
          const res = await searchAddress({ address: removeAccents(value) })
          console.log(res)
          setLoadingAddress(false)
          if (res.status === 200) setAddressList(res.data.data)
        }, 650)
      }
    } catch (error) {}
  }

  //reset
  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setFiles([])
      setFilesView([])
    } else {
      if (infoReview) {
        form.setFieldsValue({ ...infoReview })
        if (infoReview.avatar_user != '') {
          setFiles([infoReview.avatar_user])
          setFilesView(
            infoReview.avatar_user
              ? [infoReview.avatar_user].map((file, index) => {
                  const fileSplit = file.split('/')
                  const nameFile = fileSplit[fileSplit.length - 1]
                  return {
                    uid: index,
                    name: nameFile ? nameFile : 'file',
                    status: 'done',
                    url: file,
                    thumbUrl: file,
                  }
                })
              : []
          )
        }
      }
    }
  }, [visible])

  useEffect(() => {
    _getBranches()
    _getRegions()
  }, [])

  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Drawer
        title={infoReview ? 'Cập nhật review' : 'Thêm review'}
        centered
        width="80%"
        footer={
          <Row justify="end">
            <Button size="large" type="primary" onClick={_addOrUpdateReview}>
              {infoReview ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        }
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Row gutter={[30, 0]}>
            <Col md={12}>
              <Upload
                listType="picture"
                fileList={filesView}
                onRemove={(file) => {
                  const indexRemove = files.findIndex((url) => url === file)
                  if (indexRemove) {
                    const filesNew = [...files]
                    filesNew.splice(indexRemove, 1)
                    setFiles([...filesNew])
                    setFilesView([
                      ...filesNew.map((file, index) => {
                        const fileSplit = file.split('/')
                        const nameFile = fileSplit[fileSplit.length - 1]
                        return {
                          uid: index,
                          name: nameFile ? nameFile : 'file',
                          status: 'done',
                          url: file,
                          thumbUrl: file,
                        }
                      }),
                    ])
                  }
                }}
                data={async (file) => {
                  setLoadingFile(true)
                  const url = await uploadFile(file)
                  setLoadingFile(false)
                  const filesNew = [...files]
                  filesNew.push(url)
                  setFiles([...filesNew])
                  setFilesView([
                    ...filesNew.map((file, index) => {
                      const fileSplit = file.split('/')
                      const nameFile = fileSplit[fileSplit.length - 1]
                      return {
                        uid: index,
                        name: nameFile ? nameFile : 'file',
                        status: 'done',
                        url: file,
                        thumbUrl: file,
                      }
                    }),
                  ])
                }}
                onChange={(info) => {
                  if (info.file.status !== 'done') info.file.status = 'done'
                }}
              >
                <Button
                  loading={loadingFile}
                  style={{ width: 140 }}
                  size="large"
                  icon={<UploadOutlined />}
                >
                  Ảnh đại diện
                </Button>
              </Upload>
              <br />

              <div style={{ marginBottom: 15 }}>
                <Form.Item label="Tên hiển thị" name="name_user">
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Tên hiển thị"
                  />
                </Form.Item>
                <Form.Item label="Vị trí/bộ phận" name="position">
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập vị trí/bộ phận"
                  />
                </Form.Item>

                <Form.Item initialValue="" label="Nội dung" name="content">
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nội dung review"
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row gutter={[30, 0]}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                rules={[{ required: true, message: 'Vui lòng chọn khu vực' }]}
                label="Khu vực"
                name="region_ids"
              >
                <Select
                  maxTagCount="responsive"
                  mode="multiple"
                  size="large"
                  allowClear
                  optionFilterProp="children"
                  showSearch
                  placeholder="Chọn khu vực"
                >
                  {regions.map((region, index) => (
                    <Select.Option key={index} value={region.region_id}>
                      {region.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                rules={[{ required: true, message: 'Vui lòng chọn chi nhánh' }]}
                label="Chi nhánh"
                name="branch_ids"
              >
                <Select
                  maxTagCount="responsive"
                  mode="multiple"
                  size="large"
                  allowClear
                  optionFilterProp="children"
                  showSearch
                  placeholder="Chọn chi nhánh"
                >
                  {branches.map((branch, index) => (
                    <Select.Option key={index} value={branch.branch_id}>
                      {branch.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  )
}
